/** What the translator header shows for the plan: pure, so it can be tested without a DOM. */
export type HeaderPlanView =
  | { kind: 'none' }
  | { kind: 'chip'; label: 'Pro' | 'Pro+' }
  | { kind: 'meter'; pct: number; ariaLabel: string; atLimit: boolean }

export function headerPlanView(input: {
  signedIn: boolean
  /** False until the subscription answer (or cache) is in, so Pro never flashes an Upgrade button. */
  subscriptionKnown: boolean
  isPro: boolean
  isProPlus: boolean
  used: number
  limit: number
}): HeaderPlanView {
  // Signed-out visitors keep the rail's "Sign In Free"; the header adds nothing.
  if (!input.signedIn || !input.subscriptionKnown) return { kind: 'none' }
  if (input.isPro) return { kind: 'chip', label: input.isProPlus ? 'Pro+' : 'Pro' }
  const pct = input.limit > 0 ? Math.min(100, Math.max(0, (input.used / input.limit) * 100)) : 0
  return {
    kind: 'meter',
    pct,
    atLimit: input.limit > 0 && input.used >= input.limit,
    ariaLabel: `${input.used.toLocaleString('en-US')} of ${input.limit.toLocaleString('en-US')} free characters used this month`,
  }
}

export type LimitCardKind = 'monthly' | 'length'

export const LIMIT_CARD_COPY: Record<LimitCardKind, { title: string }> = {
  monthly: { title: "You've used this month's free translations" },
  length: { title: 'This text is longer than the free plan allows' },
}
export const LIMIT_CARD_BODY = 'Pro handles long texts, PDFs and images. Free for 30 days.'
